import React, { useEffect } from "react";
import './services.css'
import AOS from "aos";
import { Link } from "react-router-dom";
import "aos/dist/aos.css";
import Header from "./Header";
import Footer from "./Footer";

const Services = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);
    
    useEffect(() => {
        window.scrollTo(0, 0);   // scroll to top
        AOS.init({ duration: 1000 });
    }, []);

    const financingData = [
        {
            icon: "fas fa-chart-bar",
            title: "Patented Valuation Intelligence",
            description:
                `We eliminate the guesswork of IP appraisal. Using O'Hanlon-patented algorithms, our AI performs a forensic valuation of your portfolio, identifying hidden asset strength that traditional banks overlook.`,
            features: [
                "Forensic IP portfolio analysis",
                "Higher loan-to-value ratios",
                "Traditional bank gap identification"
            ]
        },
        {
            icon: "fas fa-shield-alt",
            title: "Proprietary Risk-Mitigation Framework",
            description:
                `Our financing structures are governed by O'Hanlon-protected risk models. This allows us to offer flexible, non-dilutive capital tailored to your innovation's lifecycle.`,
            features: [
                "Non-dilutive capital solutions",
                "Lifecycle-specific financing",
                "Generic lender alternative"
            ]
        },
        {
            icon: "fas fa-bolt",
            title: "Capital at the Speed of Innovation",
            description:
                `Don't let traditional banking cycles stall your growth. Leverage our patented efficiency models to accelerate the underwriting process.`,
            features: [
                "Accelerated underwriting",
                "Traditional cycle bypass",
                "High-performance financing"
            ]
        }
    ];
    const servicesData = [
        {
            icon: "fas fa-chart-line",
            title: "Patented Revenue Forecasting",
            description:
                "We eliminate the uncertainty of traditional underwriting. Using O'Hanlon-patented predictive algorithms, our AI analyzes historical performance and market trends to forecast future revenue.",
            tag: "AI-POWERED"
        },
        {
            icon: "fas fa-sync-alt",
            title: "Proprietary Flexible Repayment",
            description:
                "Our financing models adjust in real-time. Repayments scale dynamically with your revenue—slowing during lean months and accelerating when you grow.",
            tag: "DYNAMIC"
        },
        {
            icon: "fas fa-lock",
            title: "Non-Dilutive Capital Guardrails",
            description:
                "Protect your equity while fueling expansion. Our patented frameworks provide liquidity without sacrificing ownership.",
            tag: "SECURED"
        }
    ];

    const managementData = [
        {
            title: "Iron-Clad Ownership Protection",
            description:
                "We don't take your equity; we fuel your growth. Our O'Hanlon-patented legal framework ensures your title and rights remain fully intact, with your IP used strictly as collateral.",
            features: [
                "Full title preservation",
                "Zero equity requirement",
                "Strict collateral-only use"
            ]
        },
        {
            title: "Proprietary Confidentiality Guardrails",
            description:
                "Your sensitive data is protected within an O'Hanlon-secured environment using patented encryption and isolation protocols.",
            features: [
                "Military-grade encryption",
                "Data isolation protocols",
                "Continuous security monitoring"
            ]
        },
        {
            title: "Legally Defensible Collateralization",
            description:
                "Our patented asset-management system provides a transparent, legally secure chain of custody for your intellectual property.",
            features: [
                "Transparent chain of custody",
                "Legal compliance automation",
                "Real-time asset tracking"
            ]
        }
    ];

    const professionalServicesData = [
        {
            icon: "fas fa-umbrella",
            title: "Patent Insurance",
            description:
                "Protect your innovations with advanced legal guardrails. Our Patent Insurance programs utilize proprietary methodologies secured by O'Hanlon Patents to provide enforcement coverage and defense against infringement claims.",
            tag: "PROTECTION",
        },
        {
            icon: "fas fa-search-dollar",
            title: "Due Diligence Services",
            description:
                "Mitigate risk and validate value with the industry's most rigorous IP review process. We provide comprehensive due diligence for investments, acquisitions, and partnership opportunities.",
            tag: "RISK ASSESSMENT",
        },
        {
            icon: "fas fa-gavel",
            title: "Enforcement Support",
            description:
                "Defend your innovations with authority. Our Enforcement Support provides the strategic guidance and forensic backing needed to win licensing negotiations and litigation.",
            tag: "LEGAL SUPPORT",
        },
        {
            icon: "fas fa-book",
            title: "Educational Resources",
            description:
                "Innovation requires a master-class in strategy. Access elite IP education powered by O'Hanlon insights, including our cornerstone book and 'Patent Myths' podcast.",
            tag: "KNOWLEDGE",
        },
    ];

    const strategicManagementData = [
        {
            title: "Patented Commercial Value Creation",
            description:
                'We move beyond the "filing-first" mentality. Using O\'Hanlon-patented algorithms, we analyze your IP through a forensic commercial lens to increase valuation and drive revenue.',
            features: [
                "Forensic commercial analysis",
                "Revenue-driven IP strategy",
                "Valuation optimization",
            ],
        },
        {
            title: "Proprietary Asset Optimization",
            description:
                "We don't just manage portfolios; we optimize them for the market. Our O'Hanlon-protected framework identifies underutilized technical advantages to block competitors and secure market white space.",
            features: [
                "Market gap identification",
                "Competitive blocking strategy",
                "Portfolio optimization",
            ],
        },
        {
            title: "Outcome-Driven IP Intelligence",
            description:
                "We align your IP portfolio with long-term business goals using patented predictive modeling and exclusive O'Hanlon tools.",
            features: [
                "Predictive business alignment",
                "Exclusive tool access",
                "Long-term strategic planning",
            ],
        },
    ];

    const processSteps = [
        {
            title: "IP Portfolio Assessment & Valuation",
            description:
                `Using O'Hanlon-patented algorithms, our AI performs forensic analysis to identify hidden commercial value and monetization potential of your portfolio.`,
        },
        {
            title: "Business Financial Review",
            description:
                `Our patented fiscal intelligence engine cross-references revenue streams against IP portfolios to identify value gaps.`,
        },
        {
            title: "Loan Structuring & Terms",
            description:
                `We engineer custom structures using O'Hanlon-patented algorithms aligned with your R&D cycles and market timelines.`,
        },
        {
            title: "Funding & Ongoing Support",
            description:
                `Continuous lifecycle management with proprietary monitoring scanning for infringement risks and emerging white space.`,
        },
    ];


    useEffect(() => {

        AOS.init({
            duration: 1000,
            once: true,
            offset: 100,
            easing: "ease-in-out"
        });

        // Smooth scroll
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener("click", function (e) {
                e.preventDefault();
                const el = document.querySelector(this.getAttribute("href"));
                if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                }
            });
        });

        // Parallax hero
        const handleScroll = () => {
            const scrolled = window.pageYOffset;
            const hero = document.querySelector(".about-hero");
            if (hero) {
                hero.style.backgroundPositionY = -(scrolled * 0.5) + "px";
            }
        };

        window.addEventListener("scroll", handleScroll);

        // Intersection Observer
        const animatedElements = document.querySelectorAll(
            ".ip-financing-card, .service-card, .management-card, .process-step, .advantage-item"
        );

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = "1";
                    entry.target.style.transform = "translateY(0)";
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: "0px 0px -50px 0px"
        });

        animatedElements.forEach(el => {
            el.style.opacity = "0";
            el.style.transform = "translateY(20px)";
            el.style.transition = "opacity 0.5s ease, transform 0.5s ease";
            observer.observe(el);
        });

        // Hover animation
        const cards = document.querySelectorAll(
            ".ip-financing-card, .service-card, .management-card, .process-step"
        );

        cards.forEach(card => {
            card.addEventListener("mouseenter", function () {
                this.style.transform = "translateY(-10px) scale(1.02)";
            });

            card.addEventListener("mouseleave", function () {
                this.style.transform = "translateY(0) scale(1)";
            });
        });

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };

    }, []);

    return (
        <>
            <Header />
            {/* HERO */}
            <section className="about-hero">
                <div className="hero-background"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>

                <div className="content-container">
                    <div className="hero-content">
                        <h1 className="hero-title">Our Services - Ask Jeeves IP</h1>

                        <p className="hero-subtitle">
                            Comprehensive IP solutions that transform intellectual property into valuable
                            business assets through strategic financing, valuation, and management.
                        </p>

                        <div className="hero-tagline">
                            AI Gets You to 80%, Attorneys Take It to 100%
                        </div>
                    </div>
                </div>
            </section>


            {/* IP FINANCING */}
            <section className="ip-financing-section" id="ip-financing-section">
                <div className="content-container">

                    <div className="ip-financing-header" data-aos="fade-up">
                        <h2>IP-Collateralized Loans: Secured by O'Hanlon Patents</h2>
                        <p>
                            Unlock the hidden liquidity in your intellectual property with a
                            "Zero-Conflict" financing model.
                        </p>
                    </div>

                    <div className="ip-financing-grid">

                        {financingData.map((card, index) => (
                            <div
                                key={index}
                                className="ip-financing-card"
                                data-aos="fade-up"
                                data-aos-delay={100 * (index + 1)}
                            >

                                <div className="financing-icon">
                                    <i className={card.icon}></i>
                                </div>

                                <div className="financing-content">
                                    <h3>{card.title}</h3>
                                    <p>{card.description}</p>

                                    <div className="financing-features">
                                        {card.features.map((feature, i) => (
                                            <div key={i} className="financing-feature">
                                                <i className="fas fa-check-circle"></i>
                                                <span>{feature}</span>
                                            </div>
                                        ))}
                                    </div>

                                </div>

                            </div>
                        ))}

                    </div>

                </div>
            </section>

            <section className="professional-services-section">
                <div className="content-container">

                    <h2 data-aos="fade-up">
                        Revenue-Based Financing: Powered by O'Hanlon Patents
                    </h2>

                    <div className="services-grid">

                        {servicesData.map((service, index) => (
                            <div
                                key={index}
                                className="service-card"
                                data-aos="fade-up"
                                data-aos-delay={100 * (index + 1)}
                            >
                                <i className={service.icon}></i>

                                <h3>{service.title}</h3>

                                <p>{service.description}</p>

                                <span className="service-tag">{service.tag}</span>
                            </div>
                        ))}

                    </div>

                </div>
            </section>

            <section className="strategic-management-section">
                <div className="content-container">

                    <h2 data-aos="fade-up">
                        IP Protection: The O'Hanlon Patented Safeguard
                    </h2>

                    <div className="management-grid">

                        {managementData.map((item, index) => (
                            <div
                                key={index}
                                className="management-card"
                                data-aos="fade-up"
                                data-aos-delay={100 * (index + 1)}
                            >

                                <h3>{item.title}</h3>

                                <p>{item.description}</p>

                                <ul className="management-list">
                                    {item.features.map((feature, i) => (
                                        <li key={i}>
                                            <i className="fas fa-check"></i> {feature}
                                        </li>
                                    ))}
                                </ul>

                            </div>
                        ))}

                    </div>

                </div>
            </section>

            <section className="professional-services-section">
                <div className="content-container">
                    <h2 data-aos="fade-up">
                        Professional Services: Secured by O'Hanlon Patents
                    </h2>

                    <div className="services-grid">
                        {professionalServicesData.map((service, index) => (
                            <div
                                key={index}
                                className="service-card"
                                data-aos="fade-up"
                                data-aos-delay={100 * (index + 1)}
                            >
                                <i className={service.icon}></i>

                                <h3>{service.title}</h3>

                                <p>{service.description}</p>

                                <span className="service-tag">{service.tag}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="strategic-management-section">
                <div className="content-container">
                    <h2 data-aos="fade-up">
                        Strategic IP Management: The O'Hanlon Patented Framework
                    </h2>

                    <div className="management-grid">
                        {strategicManagementData.map((item, index) => (
                            <div
                                key={index}
                                className="management-card"
                                data-aos="fade-up"
                                data-aos-delay={100 * (index + 1)}
                            >
                                <h3>{item.title}</h3>

                                <p>{item.description}</p>

                                <ul className="management-list">
                                    {item.features.map((feature, i) => (
                                        <li key={i}>
                                            <i className="fas fa-check"></i> {feature}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className="process-section">
                <div className="content-container">
                    <h2 data-aos="fade-up">Our O'Hanlon Process Framework</h2>

                    <div className="process-steps">
                        {processSteps.map((step, index) => (
                            <div
                                key={index}
                                className="process-step"
                                data-aos="fade-up"
                                data-aos-delay={100 * (index + 1)}
                            >
                                <div className="step-number">{index + 1}</div>

                                <h4>{step.title}</h4>

                                <p>{step.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className="about-section">
                <div className="content-container">
                    <div className="about-content" data-aos="fade-up">

                        <h2>About Ask Jeeves IP</h2>

                        <p>
                            Ask Jeeves IP is a premier technology architect specializing in
                            next-generation AI-powered mobile marketing. By leveraging an
                            exclusive suite of patented O'Hanlon technologies, we transform
                            how global enterprises engage, convert, and retain audiences.
                        </p>

                        <div
                            className="about-mission"
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            <h3>Our Mission</h3>

                            <p>
                                To bridge the gap between complex intellectual property and
                                real-world growth. We provide high-performance, TCPA-compliant
                                solutions that don't just generate leads—they deliver a
                                measurable, protected, and proprietary ROI.
                            </p>
                        </div>

                    </div>
                </div>
            </section>
            {/* CTA SECTION */}
            <section className="cta-section">

                <div className="content-container">

                    <h2 data-aos="fade-up">
                        Ready to Transform Your IP into Capital?
                    </h2>

                    <p data-aos="fade-up" data-aos-delay="100">
                    Whether you need financing, valuation, or strategic IP management, Ask Jeeves IP provides an integrated ecosystem that traditional firms simply cannot match. By leveraging the O'Hanlon Patent framework, we don't just manage your intellectual property—we activate its full financial potential.
                    </p>

                    <div data-aos="fade-up" data-aos-delay="200">
                        <Link to={"/contact"}
                            className="cta-button"
                        >
                            Schedule Your O'Hanlon Strategic Audit
                        </Link>
                    </div>

                    <div className="patent-advantage" data-aos="fade-up" data-aos-delay="300">

                        <h3>The O'Hanlon Patented Advantage</h3>

                        <div className="advantage-grid">

                            <div className="advantage-item">
                                <h4>Patented Financial Orchestration</h4>
                                <p>Unlock capital based on forensic innovation strength</p>
                            </div>

                            <div className="advantage-item">
                                <h4>Strategic Growth Guardrails</h4>
                                <p>Legally defensible strategies</p>
                            </div>

                            <div className="advantage-item">
                                <h4>Elite Expertise & Automation</h4>
                                <p>AI-driven precision fused with legal intelligence</p>
                            </div>

                        </div>

                    </div>

                </div>

            </section>
            <Footer />
        </>
    );
};

export default Services;